/* tslint:disable */
/* eslint-disable */
/**
 * Files
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface Data
 */
export interface Data {
    /**
     * 
     * @type {string}
     * @memberof Data
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof Data
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Data
     */
    'lid'?: string;
}
/**
 * 
 * @export
 * @interface FileAttributes
 */
export interface FileAttributes {
    /**
     * 
     * @type {string}
     * @memberof FileAttributes
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof FileAttributes
     */
    'download_url'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FileAttributes
     */
    'size': number;
    /**
     * 
     * @type {string}
     * @memberof FileAttributes
     */
    'content_type': string;
    /**
     * 
     * @type {string}
     * @memberof FileAttributes
     */
    'created_at': string;
}
/**
 * 
 * @export
 * @interface FileResponse
 */
export interface FileResponse {
    /**
     * 
     * @type {JsonApiResourceObjectFileAttributesFileMetaData}
     * @memberof FileResponse
     */
    'data'?: JsonApiResourceObjectFileAttributesFileMetaData | null;
    /**
     * 
     * @type {object}
     * @memberof FileResponse
     */
    'meta'?: object;
    /**
     * 
     * @type {JsonApiSuccessResponseLinks}
     * @memberof FileResponse
     */
    'links': JsonApiSuccessResponseLinks;
}
/**
 * 
 * @export
 * @interface FileUploadAttributes
 */
export interface FileUploadAttributes {
    /**
     * 
     * @type {string}
     * @memberof FileUploadAttributes
     */
    'upload_url': string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof FileUploadAttributes
     */
    'form_fields': { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof FileUploadAttributes
     */
    'content_type': string;
}
/**
 * 
 * @export
 * @interface FileUploadData
 */
export interface FileUploadData {
    /**
     * 
     * @type {string}
     * @memberof FileUploadData
     */
    'type': FileUploadDataTypeEnum;
    /**
     * 
     * @type {FileUploadRequestAttributes}
     * @memberof FileUploadData
     */
    'attributes': FileUploadRequestAttributes;
}

/**
    * @export
    * @enum {string}
    */
export enum FileUploadDataTypeEnum {
    FILE_UPLOADS = 'file_uploads'
}

/**
 * 
 * @export
 * @interface FileUploadMetaData
 */
export interface FileUploadMetaData {
    /**
     * 
     * @type {number}
     * @memberof FileUploadMetaData
     */
    'expires_in': number;
    /**
     * 
     * @type {number}
     * @memberof FileUploadMetaData
     */
    'file_size_limit_bytes': number;
    /**
     * 
     * @type {string}
     * @memberof FileUploadMetaData
     */
    'env': FileUploadMetaDataEnvEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum FileUploadMetaDataEnvEnum {
    SANDBOX = 'sandbox',
    LIVE = 'live'
}

/**
 * 
 * @export
 * @interface FileUploadRequest
 */
export interface FileUploadRequest {
    /**
     * 
     * @type {FileUploadData}
     * @memberof FileUploadRequest
     */
    'data': FileUploadData;
}
/**
 * 
 * @export
 * @interface FileUploadRequestAttributes
 */
export interface FileUploadRequestAttributes {
    /**
     * The name of the file. Must have a file extension (.txt, for example).
     * @type {string}
     * @memberof FileUploadRequestAttributes
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface FileUploadResponse
 */
export interface FileUploadResponse {
    /**
     * 
     * @type {JsonApiResourceObjectFileUploadAttributesFileUploadMetaData}
     * @memberof FileUploadResponse
     */
    'data'?: JsonApiResourceObjectFileUploadAttributesFileUploadMetaData | null;
    /**
     * 
     * @type {object}
     * @memberof FileUploadResponse
     */
    'meta'?: object;
    /**
     * 
     * @type {JsonApiSuccessResponseLinks}
     * @memberof FileUploadResponse
     */
    'links': JsonApiSuccessResponseLinks;
}
/**
 * 
 * @export
 * @interface FilesResponse
 */
export interface FilesResponse {
    /**
     * 
     * @type {Array<JsonApiResourceObjectFileAttributesFileMetaData>}
     * @memberof FilesResponse
     */
    'data': Array<JsonApiResourceObjectFileAttributesFileMetaData>;
    /**
     * 
     * @type {object}
     * @memberof FilesResponse
     */
    'meta'?: object;
    /**
     * 
     * @type {JsonApiSuccessPaginationLinks}
     * @memberof FilesResponse
     */
    'links': JsonApiSuccessPaginationLinks;
}
/**
 * 
 * @export
 * @interface HTTPValidationError
 */
export interface HTTPValidationError {
    /**
     * 
     * @type {Array<ValidationError>}
     * @memberof HTTPValidationError
     */
    'detail'?: Array<ValidationError>;
}
/**
 * Resource identifier object
 * @export
 * @interface JsonApiIdentifier
 */
export interface JsonApiIdentifier {
    /**
     * 
     * @type {string}
     * @memberof JsonApiIdentifier
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof JsonApiIdentifier
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JsonApiIdentifier
     */
    'lid'?: string | null;
}
/**
 * A relationship object.
 * @export
 * @interface JsonApiRelationship
 */
export interface JsonApiRelationship {
    /**
     * 
     * @type {Data}
     * @memberof JsonApiRelationship
     */
    'data'?: Data | null;
}
/**
 * 
 * @export
 * @interface JsonApiResourceObjectFileAttributesFileMetaData
 */
export interface JsonApiResourceObjectFileAttributesFileMetaData {
    /**
     * 
     * @type {string}
     * @memberof JsonApiResourceObjectFileAttributesFileMetaData
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof JsonApiResourceObjectFileAttributesFileMetaData
     */
    'id': string;
    /**
     * 
     * @type {FileAttributes}
     * @memberof JsonApiResourceObjectFileAttributesFileMetaData
     */
    'attributes': FileAttributes;
    /**
     * 
     * @type {object}
     * @memberof JsonApiResourceObjectFileAttributesFileMetaData
     */
    'meta'?: object;
    /**
     * 
     * @type {{ [key: string]: JsonApiRelationship; }}
     * @memberof JsonApiResourceObjectFileAttributesFileMetaData
     */
    'relationships'?: { [key: string]: JsonApiRelationship; } | null;
}
/**
 * 
 * @export
 * @interface JsonApiResourceObjectFileUploadAttributesFileUploadMetaData
 */
export interface JsonApiResourceObjectFileUploadAttributesFileUploadMetaData {
    /**
     * 
     * @type {string}
     * @memberof JsonApiResourceObjectFileUploadAttributesFileUploadMetaData
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof JsonApiResourceObjectFileUploadAttributesFileUploadMetaData
     */
    'id': string;
    /**
     * 
     * @type {FileUploadAttributes}
     * @memberof JsonApiResourceObjectFileUploadAttributesFileUploadMetaData
     */
    'attributes': FileUploadAttributes;
    /**
     * 
     * @type {FileUploadMetaData}
     * @memberof JsonApiResourceObjectFileUploadAttributesFileUploadMetaData
     */
    'meta'?: FileUploadMetaData | null;
    /**
     * 
     * @type {{ [key: string]: JsonApiRelationship; }}
     * @memberof JsonApiResourceObjectFileUploadAttributesFileUploadMetaData
     */
    'relationships'?: { [key: string]: JsonApiRelationship; } | null;
}
/**
 * A JSON:API compliant response.
 * @export
 * @interface JsonApiSuccessPaginationLinks
 */
export interface JsonApiSuccessPaginationLinks {
    /**
     * 
     * @type {string}
     * @memberof JsonApiSuccessPaginationLinks
     */
    'self': string;
    /**
     * 
     * @type {string}
     * @memberof JsonApiSuccessPaginationLinks
     */
    'next'?: string | null;
}
/**
 * A JSON:API compliant response.
 * @export
 * @interface JsonApiSuccessResponseLinks
 */
export interface JsonApiSuccessResponseLinks {
    /**
     * 
     * @type {string}
     * @memberof JsonApiSuccessResponseLinks
     */
    'self': string;
}
/**
 * 
 * @export
 * @interface ValidationError
 */
export interface ValidationError {
    /**
     * 
     * @type {Array<ValidationErrorLocInner>}
     * @memberof ValidationError
     */
    'loc': Array<ValidationErrorLocInner>;
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'msg': string;
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'type': string;
}
/**
 * 
 * @export
 * @interface ValidationErrorLocInner
 */
export interface ValidationErrorLocInner {
}

/**
 * FilesDataApi - axios parameter creator
 * @export
 */
export const FilesDataApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get File
         * @param {string} fileId The unique identifier of the file
         * @param {GetFileEnvFilesFileIdGetEnvEnum} env The environment to get the file from
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFileEnvFilesFileIdGet: async (fileId: string, env: GetFileEnvFilesFileIdGetEnvEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('getFileEnvFilesFileIdGet', 'fileId', fileId)
            // verify required parameter 'env' is not null or undefined
            assertParamExists('getFileEnvFilesFileIdGet', 'env', env)
            const localVarPath = `/{env}/files/{file_id}`
                .replace(`{${"file_id"}}`, encodeURIComponent(String(fileId)))
                .replace(`{${"env"}}`, encodeURIComponent(String(env)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get File
         * @param {string} fileId The unique identifier of the file
         * @param {GetFileEnvFilesFileIdGet0EnvEnum} env The environment to get the file from
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFileEnvFilesFileIdGet_1: async (fileId: string, env: GetFileEnvFilesFileIdGet0EnvEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('getFileEnvFilesFileIdGet_1', 'fileId', fileId)
            // verify required parameter 'env' is not null or undefined
            assertParamExists('getFileEnvFilesFileIdGet_1', 'env', env)
            const localVarPath = `/{env}/files/{file_id}`
                .replace(`{${"file_id"}}`, encodeURIComponent(String(fileId)))
                .replace(`{${"env"}}`, encodeURIComponent(String(env)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Files
         * @param {GetFilesEnvFilesGetEnvEnum} env The environment to get the file from
         * @param {string} filterId Comma-separated list of file IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilesEnvFilesGet: async (env: GetFilesEnvFilesGetEnvEnum, filterId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'env' is not null or undefined
            assertParamExists('getFilesEnvFilesGet', 'env', env)
            // verify required parameter 'filterId' is not null or undefined
            assertParamExists('getFilesEnvFilesGet', 'filterId', filterId)
            const localVarPath = `/{env}/files`
                .replace(`{${"env"}}`, encodeURIComponent(String(env)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (filterId !== undefined) {
                localVarQueryParameter['filter[id]'] = filterId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Files
         * @param {GetFilesEnvFilesGet0EnvEnum} env The environment to get the file from
         * @param {string} filterId Comma-separated list of file IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilesEnvFilesGet_2: async (env: GetFilesEnvFilesGet0EnvEnum, filterId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'env' is not null or undefined
            assertParamExists('getFilesEnvFilesGet_2', 'env', env)
            // verify required parameter 'filterId' is not null or undefined
            assertParamExists('getFilesEnvFilesGet_2', 'filterId', filterId)
            const localVarPath = `/{env}/files`
                .replace(`{${"env"}}`, encodeURIComponent(String(env)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (filterId !== undefined) {
                localVarQueryParameter['filter[id]'] = filterId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload File
         * @param {UploadFileEnvFilesPostEnvEnum} env The environment to upload the file to
         * @param {FileUploadRequest} fileUploadRequest 
         * @param {string} [xFileSource] Source of the file being uploaded
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadFileEnvFilesPost: async (env: UploadFileEnvFilesPostEnvEnum, fileUploadRequest: FileUploadRequest, xFileSource?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'env' is not null or undefined
            assertParamExists('uploadFileEnvFilesPost', 'env', env)
            // verify required parameter 'fileUploadRequest' is not null or undefined
            assertParamExists('uploadFileEnvFilesPost', 'fileUploadRequest', fileUploadRequest)
            const localVarPath = `/{env}/files`
                .replace(`{${"env"}}`, encodeURIComponent(String(env)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (xFileSource != null) {
                localVarHeaderParameter['x-file-source'] = String(xFileSource);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fileUploadRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload File
         * @param {UploadFileEnvFilesPost0EnvEnum} env The environment to upload the file to
         * @param {FileUploadRequest} fileUploadRequest 
         * @param {string} [xFileSource] Source of the file being uploaded
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadFileEnvFilesPost_3: async (env: UploadFileEnvFilesPost0EnvEnum, fileUploadRequest: FileUploadRequest, xFileSource?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'env' is not null or undefined
            assertParamExists('uploadFileEnvFilesPost_3', 'env', env)
            // verify required parameter 'fileUploadRequest' is not null or undefined
            assertParamExists('uploadFileEnvFilesPost_3', 'fileUploadRequest', fileUploadRequest)
            const localVarPath = `/{env}/files`
                .replace(`{${"env"}}`, encodeURIComponent(String(env)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (xFileSource != null) {
                localVarHeaderParameter['x-file-source'] = String(xFileSource);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fileUploadRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FilesDataApi - functional programming interface
 * @export
 */
export const FilesDataApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FilesDataApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get File
         * @param {string} fileId The unique identifier of the file
         * @param {GetFileEnvFilesFileIdGetEnvEnum} env The environment to get the file from
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFileEnvFilesFileIdGet(fileId: string, env: GetFileEnvFilesFileIdGetEnvEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFileEnvFilesFileIdGet(fileId, env, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FilesDataApi.getFileEnvFilesFileIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get File
         * @param {string} fileId The unique identifier of the file
         * @param {GetFileEnvFilesFileIdGet0EnvEnum} env The environment to get the file from
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFileEnvFilesFileIdGet_1(fileId: string, env: GetFileEnvFilesFileIdGet0EnvEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFileEnvFilesFileIdGet_1(fileId, env, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FilesDataApi.getFileEnvFilesFileIdGet_1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Files
         * @param {GetFilesEnvFilesGetEnvEnum} env The environment to get the file from
         * @param {string} filterId Comma-separated list of file IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFilesEnvFilesGet(env: GetFilesEnvFilesGetEnvEnum, filterId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FilesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFilesEnvFilesGet(env, filterId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FilesDataApi.getFilesEnvFilesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Files
         * @param {GetFilesEnvFilesGet0EnvEnum} env The environment to get the file from
         * @param {string} filterId Comma-separated list of file IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFilesEnvFilesGet_2(env: GetFilesEnvFilesGet0EnvEnum, filterId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FilesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFilesEnvFilesGet_2(env, filterId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FilesDataApi.getFilesEnvFilesGet_2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Upload File
         * @param {UploadFileEnvFilesPostEnvEnum} env The environment to upload the file to
         * @param {FileUploadRequest} fileUploadRequest 
         * @param {string} [xFileSource] Source of the file being uploaded
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadFileEnvFilesPost(env: UploadFileEnvFilesPostEnvEnum, fileUploadRequest: FileUploadRequest, xFileSource?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileUploadResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadFileEnvFilesPost(env, fileUploadRequest, xFileSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FilesDataApi.uploadFileEnvFilesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Upload File
         * @param {UploadFileEnvFilesPost0EnvEnum} env The environment to upload the file to
         * @param {FileUploadRequest} fileUploadRequest 
         * @param {string} [xFileSource] Source of the file being uploaded
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadFileEnvFilesPost_3(env: UploadFileEnvFilesPost0EnvEnum, fileUploadRequest: FileUploadRequest, xFileSource?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileUploadResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadFileEnvFilesPost_3(env, fileUploadRequest, xFileSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FilesDataApi.uploadFileEnvFilesPost_3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FilesDataApi - factory interface
 * @export
 */
export const FilesDataApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FilesDataApiFp(configuration)
    return {
        /**
         * 
         * @summary Get File
         * @param {FilesDataApiGetFileEnvFilesFileIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFileEnvFilesFileIdGet(requestParameters: FilesDataApiGetFileEnvFilesFileIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<FileResponse> {
            return localVarFp.getFileEnvFilesFileIdGet(requestParameters.fileId, requestParameters.env, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get File
         * @param {FilesDataApiGetFileEnvFilesFileIdGet0Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFileEnvFilesFileIdGet_1(requestParameters: FilesDataApiGetFileEnvFilesFileIdGet0Request, options?: RawAxiosRequestConfig): AxiosPromise<FileResponse> {
            return localVarFp.getFileEnvFilesFileIdGet_1(requestParameters.fileId, requestParameters.env, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Files
         * @param {FilesDataApiGetFilesEnvFilesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilesEnvFilesGet(requestParameters: FilesDataApiGetFilesEnvFilesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<FilesResponse> {
            return localVarFp.getFilesEnvFilesGet(requestParameters.env, requestParameters.filterId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Files
         * @param {FilesDataApiGetFilesEnvFilesGet0Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilesEnvFilesGet_2(requestParameters: FilesDataApiGetFilesEnvFilesGet0Request, options?: RawAxiosRequestConfig): AxiosPromise<FilesResponse> {
            return localVarFp.getFilesEnvFilesGet_2(requestParameters.env, requestParameters.filterId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload File
         * @param {FilesDataApiUploadFileEnvFilesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadFileEnvFilesPost(requestParameters: FilesDataApiUploadFileEnvFilesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<FileUploadResponse> {
            return localVarFp.uploadFileEnvFilesPost(requestParameters.env, requestParameters.fileUploadRequest, requestParameters.xFileSource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload File
         * @param {FilesDataApiUploadFileEnvFilesPost0Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadFileEnvFilesPost_3(requestParameters: FilesDataApiUploadFileEnvFilesPost0Request, options?: RawAxiosRequestConfig): AxiosPromise<FileUploadResponse> {
            return localVarFp.uploadFileEnvFilesPost_3(requestParameters.env, requestParameters.fileUploadRequest, requestParameters.xFileSource, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getFileEnvFilesFileIdGet operation in FilesDataApi.
 * @export
 * @interface FilesDataApiGetFileEnvFilesFileIdGetRequest
 */
export interface FilesDataApiGetFileEnvFilesFileIdGetRequest {
    /**
     * The unique identifier of the file
     * @type {string}
     * @memberof FilesDataApiGetFileEnvFilesFileIdGet
     */
    readonly fileId: string

    /**
     * The environment to get the file from
     * @type {'sandbox' | 'live'}
     * @memberof FilesDataApiGetFileEnvFilesFileIdGet
     */
    readonly env: GetFileEnvFilesFileIdGetEnvEnum
}

/**
 * Request parameters for getFileEnvFilesFileIdGet_1 operation in FilesDataApi.
 * @export
 * @interface FilesDataApiGetFileEnvFilesFileIdGet0Request
 */
export interface FilesDataApiGetFileEnvFilesFileIdGet0Request {
    /**
     * The unique identifier of the file
     * @type {string}
     * @memberof FilesDataApiGetFileEnvFilesFileIdGet0
     */
    readonly fileId: string

    /**
     * The environment to get the file from
     * @type {'sandbox' | 'live'}
     * @memberof FilesDataApiGetFileEnvFilesFileIdGet0
     */
    readonly env: GetFileEnvFilesFileIdGet0EnvEnum
}

/**
 * Request parameters for getFilesEnvFilesGet operation in FilesDataApi.
 * @export
 * @interface FilesDataApiGetFilesEnvFilesGetRequest
 */
export interface FilesDataApiGetFilesEnvFilesGetRequest {
    /**
     * The environment to get the file from
     * @type {'sandbox' | 'live'}
     * @memberof FilesDataApiGetFilesEnvFilesGet
     */
    readonly env: GetFilesEnvFilesGetEnvEnum

    /**
     * Comma-separated list of file IDs
     * @type {string}
     * @memberof FilesDataApiGetFilesEnvFilesGet
     */
    readonly filterId: string
}

/**
 * Request parameters for getFilesEnvFilesGet_2 operation in FilesDataApi.
 * @export
 * @interface FilesDataApiGetFilesEnvFilesGet0Request
 */
export interface FilesDataApiGetFilesEnvFilesGet0Request {
    /**
     * The environment to get the file from
     * @type {'sandbox' | 'live'}
     * @memberof FilesDataApiGetFilesEnvFilesGet0
     */
    readonly env: GetFilesEnvFilesGet0EnvEnum

    /**
     * Comma-separated list of file IDs
     * @type {string}
     * @memberof FilesDataApiGetFilesEnvFilesGet0
     */
    readonly filterId: string
}

/**
 * Request parameters for uploadFileEnvFilesPost operation in FilesDataApi.
 * @export
 * @interface FilesDataApiUploadFileEnvFilesPostRequest
 */
export interface FilesDataApiUploadFileEnvFilesPostRequest {
    /**
     * The environment to upload the file to
     * @type {'sandbox' | 'live'}
     * @memberof FilesDataApiUploadFileEnvFilesPost
     */
    readonly env: UploadFileEnvFilesPostEnvEnum

    /**
     * 
     * @type {FileUploadRequest}
     * @memberof FilesDataApiUploadFileEnvFilesPost
     */
    readonly fileUploadRequest: FileUploadRequest

    /**
     * Source of the file being uploaded
     * @type {string}
     * @memberof FilesDataApiUploadFileEnvFilesPost
     */
    readonly xFileSource?: string
}

/**
 * Request parameters for uploadFileEnvFilesPost_3 operation in FilesDataApi.
 * @export
 * @interface FilesDataApiUploadFileEnvFilesPost0Request
 */
export interface FilesDataApiUploadFileEnvFilesPost0Request {
    /**
     * The environment to upload the file to
     * @type {'sandbox' | 'live'}
     * @memberof FilesDataApiUploadFileEnvFilesPost0
     */
    readonly env: UploadFileEnvFilesPost0EnvEnum

    /**
     * 
     * @type {FileUploadRequest}
     * @memberof FilesDataApiUploadFileEnvFilesPost0
     */
    readonly fileUploadRequest: FileUploadRequest

    /**
     * Source of the file being uploaded
     * @type {string}
     * @memberof FilesDataApiUploadFileEnvFilesPost0
     */
    readonly xFileSource?: string
}

/**
 * FilesDataApi - object-oriented interface
 * @export
 * @class FilesDataApi
 * @extends {BaseAPI}
 */
export class FilesDataApi extends BaseAPI {
    /**
     * 
     * @summary Get File
     * @param {FilesDataApiGetFileEnvFilesFileIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilesDataApi
     */
    public getFileEnvFilesFileIdGet(requestParameters: FilesDataApiGetFileEnvFilesFileIdGetRequest, options?: RawAxiosRequestConfig) {
        return FilesDataApiFp(this.configuration).getFileEnvFilesFileIdGet(requestParameters.fileId, requestParameters.env, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get File
     * @param {FilesDataApiGetFileEnvFilesFileIdGet0Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilesDataApi
     */
    public getFileEnvFilesFileIdGet_1(requestParameters: FilesDataApiGetFileEnvFilesFileIdGet0Request, options?: RawAxiosRequestConfig) {
        return FilesDataApiFp(this.configuration).getFileEnvFilesFileIdGet_1(requestParameters.fileId, requestParameters.env, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Files
     * @param {FilesDataApiGetFilesEnvFilesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilesDataApi
     */
    public getFilesEnvFilesGet(requestParameters: FilesDataApiGetFilesEnvFilesGetRequest, options?: RawAxiosRequestConfig) {
        return FilesDataApiFp(this.configuration).getFilesEnvFilesGet(requestParameters.env, requestParameters.filterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Files
     * @param {FilesDataApiGetFilesEnvFilesGet0Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilesDataApi
     */
    public getFilesEnvFilesGet_2(requestParameters: FilesDataApiGetFilesEnvFilesGet0Request, options?: RawAxiosRequestConfig) {
        return FilesDataApiFp(this.configuration).getFilesEnvFilesGet_2(requestParameters.env, requestParameters.filterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload File
     * @param {FilesDataApiUploadFileEnvFilesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilesDataApi
     */
    public uploadFileEnvFilesPost(requestParameters: FilesDataApiUploadFileEnvFilesPostRequest, options?: RawAxiosRequestConfig) {
        return FilesDataApiFp(this.configuration).uploadFileEnvFilesPost(requestParameters.env, requestParameters.fileUploadRequest, requestParameters.xFileSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload File
     * @param {FilesDataApiUploadFileEnvFilesPost0Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilesDataApi
     */
    public uploadFileEnvFilesPost_3(requestParameters: FilesDataApiUploadFileEnvFilesPost0Request, options?: RawAxiosRequestConfig) {
        return FilesDataApiFp(this.configuration).uploadFileEnvFilesPost_3(requestParameters.env, requestParameters.fileUploadRequest, requestParameters.xFileSource, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
  * @export
  * @enum {string}
  */
export enum GetFileEnvFilesFileIdGetEnvEnum {
    SANDBOX = 'sandbox',
    LIVE = 'live'
}
/**
  * @export
  * @enum {string}
  */
export enum GetFileEnvFilesFileIdGet0EnvEnum {
    SANDBOX = 'sandbox',
    LIVE = 'live'
}
/**
  * @export
  * @enum {string}
  */
export enum GetFilesEnvFilesGetEnvEnum {
    SANDBOX = 'sandbox',
    LIVE = 'live'
}
/**
  * @export
  * @enum {string}
  */
export enum GetFilesEnvFilesGet0EnvEnum {
    SANDBOX = 'sandbox',
    LIVE = 'live'
}
/**
  * @export
  * @enum {string}
  */
export enum UploadFileEnvFilesPostEnvEnum {
    SANDBOX = 'sandbox',
    LIVE = 'live'
}
/**
  * @export
  * @enum {string}
  */
export enum UploadFileEnvFilesPost0EnvEnum {
    SANDBOX = 'sandbox',
    LIVE = 'live'
}


